"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTER_SET_PARAMS_TYPE = exports.ROUTER_BACK_TYPE = exports.ROUTER_DISMISS_TYPE = exports.ROUTER_DISMISS_ALL_TYPE = exports.ROUTER_LINK_TYPE = void 0;
exports.ROUTER_LINK_TYPE = '$$router_link';
exports.ROUTER_DISMISS_ALL_TYPE = '$$router_dismissAll';
exports.ROUTER_DISMISS_TYPE = '$$router_dismiss';
exports.ROUTER_BACK_TYPE = '$$router_goBack';
exports.ROUTER_SET_PARAMS_TYPE = '$$router_setParams';
//# sourceMappingURL=events.js.map